/* Classic Warehouse theme scripts */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((cents || 0) / 100);
  };

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-menu]');
  var opener = $('[data-menu-open]');
  function openMenu() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('no-scroll');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var close = $('[data-menu-close]', drawer);
    if (close) close.focus();
  }
  function closeMenu() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.classList.remove('no-scroll');
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
  }
  if (opener) opener.addEventListener('click', openMenu);
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeMega(); }
  });
  window.addEventListener('resize', function () { if (window.innerWidth >= 990) closeMenu(); });

  /* ---------- Mega menu (click / keyboard; hover handled in CSS) ---------- */
  var mega = $('[data-mega]');
  var megaBtn = $('[data-mega-toggle]');
  function closeMega() {
    if (!mega) return;
    mega.classList.remove('is-open');
    if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false');
  }
  if (megaBtn) {
    megaBtn.addEventListener('click', function () {
      var open = !mega.classList.contains('is-open');
      mega.classList.toggle('is-open', open);
      megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) { if (mega && !mega.contains(e.target)) closeMega(); });
  }

  /* ---------- Auto-submit selects / cart quantities ---------- */
  $$('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { if (el.form) el.form.submit(); });
  });

  /* ---------- Product gallery ---------- */
  var mainImg = document.getElementById('GalleryMain');
  $$('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.dataset.src; mainImg.srcset = btn.dataset.srcset;
      $$('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  /* ---------- Product tile calculator ---------- */
  $$('[data-calc] [data-sqm]').forEach(function (card) {
    var form = card.closest('form');
    var sqm = parseFloat(card.dataset.sqm) || 0;
    var price = parseInt(card.dataset.price, 10) || 0;
    var compare = parseInt(card.dataset.compare, 10) || 0;
    var areasEl = $('[data-areas]', card);
    var qty = $('[data-qty]', card);
    var waste = 10;
    var areas = [{ l: '', w: '' }];
    var manual = false;
    var num = function (v) { v = parseFloat(String(v).replace(',', '.')); return isFinite(v) && v > 0 ? v : 0; };

    function renderAreas() {
      areasEl.innerHTML = '';
      areas.forEach(function (a, i) {
        var row = document.createElement('div');
        row.className = 'area';
        var id = 'a' + Math.random().toString(36).slice(2, 7);
        row.innerHTML =
          '<label class="area__f"><span>Length (m)</span><input id="' + id + 'l" type="number" inputmode="decimal" min="0" step="0.1" placeholder="0.0" value="' + a.l + '" aria-label="Area ' + (i + 1) + ' length in metres" data-l></label>' +
          '<span class="area__x" aria-hidden="true">×</span>' +
          '<label class="area__f"><span>Width (m)</span><input id="' + id + 'w" type="number" inputmode="decimal" min="0" step="0.1" placeholder="0.0" value="' + a.w + '" aria-label="Area ' + (i + 1) + ' width in metres" data-w></label>' +
          '<span class="area__m2" aria-live="polite"><b data-m2>0.00</b> m²</span>' +
          (areas.length > 1 ? '<button type="button" class="area__rm" data-remove aria-label="Remove area ' + (i + 1) + '">×</button>' : '');
        row.classList.toggle('area--multi', areas.length > 1);
        $('[data-l]', row).addEventListener('input', function (e) { a.l = e.target.value; manual = false; update(); });
        $('[data-w]', row).addEventListener('input', function (e) { a.w = e.target.value; manual = false; update(); });
        var rm = $('[data-remove]', row);
        if (rm) rm.addEventListener('click', function () { areas.splice(i, 1); renderAreas(); update(); });
        areasEl.appendChild(row);
      });
    }

    function update() {
      var total = 0;
      $$('.area', areasEl).forEach(function (row, i) {
        var m2 = num(areas[i].l) * num(areas[i].w);
        total += m2;
        $('[data-m2]', row).textContent = m2.toFixed(2);
      });
      var boxes = Math.max(1, parseInt(qty.value, 10) || 1);
      if (!manual && total > 0 && sqm > 0) {
        boxes = Math.ceil((total * (1 + waste / 100)) / sqm - 1e-9);
        qty.value = boxes;
      }
      var word = boxes === 1 ? (card.dataset.word || 'box') : (card.dataset.words || 'boxes');
      $('[data-out-area]', card).textContent = total.toFixed(2);
      var need = $('[data-out-need]', card);
      if (need) need.textContent = total > 0 ? (waste ? 'with ' + waste + '% extra: ' + (total * (1 + waste / 100)).toFixed(2) + ' m²' : 'no extra added') + ' → ' + boxes + ' ' + word : '';
      $('[data-out-cover]', card).textContent = (boxes * sqm).toFixed(2);
      var bt = $('[data-out-boxes-txt]', card);
      if (bt) bt.textContent = boxes + ' ' + word;
      $('[data-out-total]', card).textContent = money(boxes * price);
      var save = $('[data-out-save]', card);
      if (save) save.textContent = money(boxes * Math.max(0, compare - price));
      var b = form && $('[data-out-boxes]', form);
      if (b) b.textContent = boxes;
      var w = form && $('[data-out-word]', form);
      if (w) w.textContent = word;
    }

    $('[data-add-area]', card).addEventListener('click', function () { areas.push({ l: '', w: '' }); renderAreas(); update(); });
    /* Extra for cuts & wastage: one slider (0–50%) with preset dots every 10% */
    var cuts = $('[data-cuts]', card);
    if (cuts) {
      var MAX = 50, PRE = [0, 10, 20, 30, 40, 50];
      cuts.innerHTML =
        '<div class="cuts__head"><label class="cuts__label" for="Cuts-' + (form ? form.id || 'p' : 'p') + '">Extra for cuts &amp; wastage</label><b class="cuts__val" data-cuts-val></b></div>' +
        '<div class="cuts__track"><span class="cuts__fill" data-cuts-fill></span>' +
        PRE.map(function (p) { return '<span class="cuts__dot" data-dot="' + p + '" style="left:' + (p / MAX * 100) + '%"></span>'; }).join('') +
        '<input id="Cuts-' + (form ? form.id || 'p' : 'p') + '" type="range" min="0" max="' + MAX + '" step="1" value="' + waste + '" data-cuts-range aria-valuetext="10% extra"></div>' +
        '<div class="cuts__marks">' + PRE.map(function (p) { return '<button type="button" data-waste="' + p + '" style="left:' + (p / MAX * 100) + '%">' + (p ? p + '%' : 'None') + '</button>'; }).join('') + '</div>' +
        '<p class="cuts__tip" data-cuts-tip></p>';
      var range = $('[data-cuts-range]', cuts);
      var setCuts = function (v) {
        waste = Math.max(0, Math.min(MAX, v));
        range.value = waste;
        var pct = waste / MAX * 100;
        $('[data-cuts-fill]', cuts).style.width = pct + '%';
        $('[data-cuts-val]', cuts).textContent = waste ? '+' + waste + '%' : 'None';
        range.setAttribute('aria-valuetext', waste ? waste + '% extra' : 'No extra');
        $$('[data-dot]', cuts).forEach(function (d) { d.classList.toggle('is-on', +d.dataset.dot <= waste); });
        $$('[data-waste]', cuts).forEach(function (b) { var on = +b.dataset.waste === waste; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        $('[data-cuts-tip]', cuts).textContent = waste === 0 ? 'No allowance for cuts or breakages — only if your area needs no cutting.'
          : waste < 10 ? 'A small allowance — best for large, simple rooms.'
          : waste < 15 ? 'Suits a straight or offset lay.'
          : waste <= 20 ? 'Suits diagonal or herringbone layouts, or rooms with lots of cuts.'
          : waste <= 30 ? 'A generous allowance — handy for complex rooms or keeping spares.'
          : 'A large allowance — for intricate patterns, lots of small cuts, or plenty of spares.';
        manual = false; update();
      };
      range.addEventListener('input', function () {
        var v = +range.value;
        PRE.forEach(function (p) { if (Math.abs(v - p) <= 1) v = p; }); /* snap to the dots */
        setCuts(v);
      });
      $$('[data-waste]', cuts).forEach(function (b) { b.addEventListener('click', function () { setCuts(+b.dataset.waste); }); });
      setCuts(waste);
    }
    qty.addEventListener('input', function () { manual = true; update(); });
    renderAreas(); update();
  });

  /* ---------- Quantity steppers (product form) ---------- */
  $$('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentNode.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  /* ---------- Standalone area calculator ---------- */
  $$('[data-area-calc]').forEach(function (el) {
    var mode = 'floor';
    var num = function (s) { var v = parseFloat($(s, el).value); return isFinite(v) && v > 0 ? v : 0; };
    function update() {
      var area = num('[data-len]') * num('[data-wid]') - (mode === 'wall' ? num('[data-open]') : 0);
      area = Math.max(0, area);
      var need = area * (1 + parseInt($('[data-waste-select]', el).value, 10) / 100);
      var box = num('[data-box]');
      $('[data-o-area]', el).textContent = area.toFixed(2);
      $('[data-o-need]', el).textContent = need.toFixed(2);
      $('[data-o-boxes]', el).textContent = box > 0 ? Math.ceil(need / box - 1e-9) : '–';
    }
    $$('input, select', el).forEach(function (i) { i.addEventListener('input', update); });
    $$('[data-mode]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.dataset.mode;
        $$('[data-mode]', el).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $('[data-open-field]', el).hidden = mode !== 'wall';
        $('[data-wid-label]', el).textContent = mode === 'wall' ? 'Tiled height (m)' : 'Width (m)';
        update();
      });
    });
    update();
  });

  /* ---------- Tabs (finish guide) ---------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var tabs = $$('[data-tab]', wrap), panels = $$('[data-panel]', wrap), imgs = $$('[data-panel-img]', wrap);
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (p, j) { p.hidden = j !== i; });
        imgs.forEach(function (p, j) { p.hidden = j !== i; });
      });
    });
  });

  /* ---------- Slip guide ---------- */
  $$('[data-slip-chips]').forEach(function (chips) {
    var section = chips.closest('section');
    $$('[data-slip]', chips).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('[data-slip]', chips).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-slip-card]', section).forEach(function (c) { c.hidden = c.dataset.slipCard !== b.dataset.slip; });
      });
    });
  });

  /* ---------- Tile finder ---------- */
  $$('[data-finder]').forEach(function (f) {
    var base = f.dataset.base, where = null;
    var steps = $$('[data-step]', f), dots = $$('.finder__dots span', f);
    function show(n) {
      steps.forEach(function (s) { s.hidden = s.dataset.step !== String(n); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i < n); });
    }
    $$('[data-where]', f).forEach(function (b) {
      b.addEventListener('click', function () {
        where = b.dataset.where;
        var l = $('[data-where-label]', f); if (l) l.textContent = '— ' + b.dataset.label;
        show(2);
      });
    });
    $$('[data-look]', f).forEach(function (b) {
      b.addEventListener('click', function () {
        dots.forEach(function (d) { d.classList.add('is-on'); });
        var look = b.dataset.look;
        window.location.href = base + '/' + where + (look && look !== 'all' ? '+' + look : '');
      });
    });
    var back = $('[data-back]', f);
    if (back) back.addEventListener('click', function () { show(1); });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recs]').forEach(function (el) {
    if (el.children.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recs]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  });

  /* Tile Studio now lives in assets/tile-studio.js */
})();